export function toUpperCase(e) {
  e.target.value = e.target.value.toUpperCase();
}
